import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { useEffect, FC } from 'react'
import { $convertToMarkdownString } from '@lexical/markdown'

import { ALL_TRANSFORMERS } from '../MarkdownTransformers'

interface OnChangePluginProps {
  onChange: (value: string) => void
}

/**
 * Plugin for getting current state from the markdown editor
 */
export const OnChangePlugin: FC<OnChangePluginProps> = ({ onChange }) => {
  const [editor] = useLexicalComposerContext()
  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      editorState.read(() => {
        let markodwnString = $convertToMarkdownString(ALL_TRANSFORMERS)

        // Replacing all greater and lesser symbols to safe special symbols
        markodwnString = markodwnString.replaceAll(/>/g, '&gt;').replace(/</g, '&lt;')

        onChange(markodwnString)
      })
    })
  }, [editor, onChange])
  return null
}
